import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';

type Tab = {
  label: string;
  route: string;
  key: string;
};

export interface NavigationTabsSignature {
  // The arguments accepted by the component
  Args: {
    tabs: Tab[];
    currentRouteName?: string;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: HTMLDivElement;
}

export default class NavigationTabs extends Component<NavigationTabsSignature> {
  @service declare router: RouterService;

  get currentRouteName() {
    return this.args.currentRouteName ?? this.router.currentRouteName;
  }

  @action
  isActive(tab: Tab) {
    return this.currentRouteName?.includes?.(tab.key);
  }
}
